module.exports = __webpack_public_path__ + "img/slider-13.6dd493bf.jpg";